import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import FileCopyOutlinedIcon from 'components/material-symbol/icons/FileCopy'
import CopyTextButton from '../copy-text-button'
import { useStyles } from './styles'

const BookingUrlField = ({ text, onCopy }) => {
  const classes = useStyles()

  return (
    <Box className={classes.bookingUrlRow}>
      <Box className={classes.bookingUrlField}>
        <Typography className={classes.bookingUrlText} noWrap>
          {text}
        </Typography>
      </Box>
      <CopyTextButton
        component={IconButton}
        value={text}
        className={classes.bookingUrlCopyButton}
        aria-label="Copy booking link"
        onClick={onCopy}
      >
        <FileCopyOutlinedIcon className={classes.bookingUrlCopyIcon} />
      </CopyTextButton>
    </Box>
  )
}

BookingUrlField.propTypes = {
  text: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
}

export default BookingUrlField
